import { cn } from '@/lib/utils';
import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { trackInitiateCheckout } from '../utils/metaPixel';
interface CTAButtonProps {
  label?: string;
  className?: string;
  /** Por defecto va al checkout. Pasar un ancla (#oferta) para hacer scroll interno. */
  href?: string;
  variant?: 'gold' | 'berry' | 'charcoal' | 'outline';
  showArrow?: boolean;
  size?: 'md' | 'lg';
}

/** Checkout oficial y único de 100 New York Cookies. */
export const CHECKOUT_URL = 'https://100-new-york-cookies.impultienda.ar/checkout';

/**
 * Todos los botones principales de compra usan el mismo relleno naranja
 * mandarina (#F47A2A) con texto blanco. Las variantes existen solo por
 * compatibilidad.
 */
const BERRY = 'bg-[#F47A2A] text-white hover:bg-[#DF6A1D] shadow-[0_14px_26px_-12px_rgba(244,122,42,0.55)] hover:shadow-[0_20px_34px_-14px_rgba(244,122,42,0.6)] focus-visible:ring-[#F47A2A]/50';
export function CTAButton({
  label = 'Quiero hacer estas cookies',
  className = '',
  href = CHECKOUT_URL,
  variant = 'gold',
  showArrow = true,
  size = 'md'
}: CTAButtonProps) {
  const goesToCheckout = href.startsWith(CHECKOUT_URL);
  const handleClick = () => {
    if (goesToCheckout) trackInitiateCheckout();
  };
  const palette = {
    gold: BERRY,
    berry: BERRY,
    charcoal: BERRY,
    outline: BERRY
  }[variant];
  const dimensions = size === 'lg' ? 'min-h-[62px] px-8 py-4 text-[0.88rem] sm:px-10 sm:text-[1rem]' : 'min-h-[54px] px-7 py-3.5 text-[0.82rem] sm:text-[0.9rem]';
  return <a href={href} onClick={handleClick} className={cn('group inline-flex items-center justify-center gap-2.5 rounded-full text-center font-sans font-bold uppercase leading-tight tracking-[0.07em] transition-[transform,background-color,box-shadow] duration-200 ease-out hover:-translate-y-0.5 active:translate-y-0 focus:outline-none focus-visible:ring-4', dimensions, palette, className)} data-id="element-61" data-mp="1w7jb33xub4uc">
      {label}
      {showArrow && <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform duration-200 ease-out group-hover:translate-x-1" aria-hidden data-id="element-62" data-mp="1q9po9ug0x5z1" />}
    </a>;
}